export default __webpack_public_path__ + "static/media/insppvServicesinvestment.e8a78a5b.svg";